module.exports = __webpack_public_path__ + "img/4.1c369f7e.jpg";